// extracted by css-extract-rspack-plugin
export default {"root":"_3ED75BSY54gEvuQqk-FGCQ","actions":"_3O2dhyF5XvLM17gz0Pd5UF"};